 <template>
  <!-- 主要参数
    1.isTextType 主要判断是否uoload是否是text格式  因为不同的方式样式做了区分, 不要随意更改这个
    2.isAlone  主要为了区分上传图片是否是单个 true代表上传一个回显一个 flase代表多个图片上传回显的情况
    3.不支持开启show-file-list，原生DOM模拟上传过程
    4.不支持多个文件同时上传
    5.最大上传个数为10
    6.showUploadBtnByLimit 通过最大允许上传个数控制是否展示上传按钮
   -->
  <div
    class="upload-box"
    :class="[
      isTextType ? 'textType' : 'notextType',
      isShowTitle ? 'hasTitle' : '',
    ]"
    :style="{ paddingTop: fileDataList.length && isTextType ? '6px' : 0 }"
  >
    <!-- 图片上传两种格式 -->
    <div
      class="notextType-box"
      :class="[isAlone ? 'alone' : 'noalone']"
      v-if="!isTextType"
    >
      <!-- 多张图片上传 -->
      <no-alone-box
        v-if="!isAlone"
        :fileList="fileDataList"
        :isShowTitle="isShowTitle"
        :isShowCustom="isShowCustom"
        :closeImg="closeImg"
        @deleteUploadHandle="deleteUploadHandle"
        @editTxt="editTxt"
      >
      <core-upload
        v-if="fileDataList.length < limit"
        slot="coreUpload"
        :isTextType="isTextType"
        :isAlone="isAlone"
        :drag="drag"
        :accept="accept"
        :fileTitle="fileTitle"
        :disabled="disabled"
        :limit="limit"
        :listType="listType"
        :name="name"
        :fileList="fileDataList"
        :fileSize="fileSize"
        :showUploadBtnByLimit="showUploadBtnByLimit"
        :multiple="multiple"
        :fileTitleWidth="fileTitleWidth"
        :beforeUpload="beforeUploadHandler"
        @uploadRequest="uploadRequest"
        @errorHandle="errorHandle"
        @exceedHandle="exceedHandle"
        ref="coreUpload"
      />
      </no-alone-box>
      <!-- 单张图片上传 -->
      <alone-box
        v-if="isAlone"
        :fileTitle="fileTitle"
        :imageUrl="imageUrl"
        :closeImg="closeImg"
        :isProgress="isProgress"
        :uploadPercent="uploadPercent"
        @deleteUploadHandle="deleteUploadHandle"
      />
    </div>
    <!-- 文件上传 -->
    <text-type-box
      v-if="isTextType"
      :fileList="fileDataList"
      :uploadPercent="uploadPercent"
      @deleteUploadHandle="deleteUploadHandle"
    />
    <core-upload
      v-if="isAlone || isTextType"
      :isTextType="isTextType"
      :isAlone="isAlone"
      :drag="drag"
      :accept="accept"
      :fileTitle="fileTitle"
      :disabled="disabled"
      :limit="limit"
      :listType="listType"
      :name="name"
      :fileList="fileDataList"
      :fileSize="fileSize"
      :showUploadBtnByLimit="showUploadBtnByLimit"
      :multiple="multiple"
      :fileTitleWidth="fileTitleWidth"
      :beforeUpload="beforeUploadHandler"
      @uploadRequest="uploadRequest"
      @errorHandle="errorHandle"
      @exceedHandle="exceedHandle"
      ref="coreUpload"
    />
    <edit-title-dialog
      :dialog="dialog"
      @changeCustomTitle="changeCustomTitle"
    />
  </div>
</template>

<script>
import { interfacePrefix } from '@/config'
import { getHead } from '@/utils'
import axios from 'axios'
import AloneBox from './components/AloneBox.vue'
import CoreUpload from './components/CoreUpload.vue'
import EditTitleDialog from './components/EditTitleDialog.vue'
import NoAloneBox from './components/NoAloneBox.vue'
import TextTypeBox from './components/TextTypeBox.vue'
import { validPlugins } from './validPlugin'
import uniqBy from 'lodash/uniqBy'
import isEmpty from 'lodash/isEmpty'
import reject from 'lodash/reject'

const codeList = [
  'group_employee_pic',
  'company_employee_pic',
  'assert_detail_pic',
  'assert_detail_pic',
  'assert_material_pic',
]

export default {
  name: 'UploadCommon',
  components: {
    AloneBox,
    NoAloneBox,
    TextTypeBox,
    EditTitleDialog,
    CoreUpload,
  },
  computed: {
    fileDataList() {
      // 上传文件数据处理，过滤掉数组中 不是对象 或者 是对象且无属性 的元素
      const filterList = reject(this.accFileList, isEmpty)
      return filterList.concat(this.pendingList || [])
    },
    isTextType() {
      if (this.listType === 'text') {
        return true
      }
      return false
    },
    fileSize() {
      return this.customSize || this.fileSizeData[this.sizeType]
    },
    accept() {
      if (this.acceptType) {
        return this.acceptType
      } else {
        let type = 1
        if (this.listType === 'text') {
          type = 2
          if (this.customAccept === '3') {
            type = 3
          }
        }
        return this.acceptData[type]
      }
    },
  },
  watch: {
    fileList: {
      handler() {
        // 为null、undefined
        if (!this.fileList) {
          this.imageUrl = ''
          return
        }
        this.$set(this, 'accFileList', this.fileList)
        /** 未来规范化可删除此方法 --- 此方法主要处理非法数据，对非法数据进行过滤删除（ps：）:[""]、[{}],主要解决非法数据传递过来时单张上传回显空白bug* */
        this.dataFilter()
        /** 未来规范化可删除此方法  * */
        this.imageUrl = (this.fileList[0] && this.fileList[0].url) || ''
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    isAlone: {
      type: Boolean,
      default: true,
    },
    drag: {
      type: Boolean,
      default: true,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    fileTitle: {
      type: String,
      default: '',
    },
    fileTitleWidth: { // 提示语宽度
      type: String,
      default: '145px',
    },
    limit: {
      type: Number,
      default: 1,
    },
    listType: {
      type: String,
      default: 'picture-card',
    },
    headers: {
      type: Object,
      default: () => ({}),
    },
    name: {
      type: String,
      default: 'file',
    },
    isShowCustom: {
      type: Boolean,
      default: false,
    },
    isShowTitle: {
      type: Boolean,
      default: false,
    },
    sizeType: {
      type: Number,
      default: 2,
    },
    customSize: {
      type: Number,
      default: null, // 自定义文件大小，默认5M
    },
    customAccept: {
      type: String,
    },
    showUploadBtnByLimit: {
      type: Number,
      default: null,
    },
    // 多选文件
    multiple: {
      type: Boolean,
      default: false,
    },
    // 自定义上传类型
    acceptType: {
      type: String,
      default: '',
    },
    // 公/私桶
    isPublic: {
      type: Boolean,
      default: false,
    },
    // 是否需要校验敏感性
    scannable: {
      type: Boolean,
      default: false,
    },
    // 是否校验上传了重复文件
    isCheckRepeat: {
      type: Boolean,
      default: false,
    },
    commonUpload: {
      type: Boolean,
      default: false,
    },
    group: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      duplicateFileMap: new Map(), // 重复文件list
      accFileList: [], // prop 中 fileList 的浅拷贝
      pendingList: [], // 正在上传的文件
      // 默认文件大小，1：ocr图片 2：普通资源图片 3：附件 单位mb
      fileSizeData: {
        1: 1,
        2: 10, // 10
        3: 20, // 20
        4: 100,
      },
      // 上传文件格式 设置 1为图片 2为附件
      acceptData: {
        1: '.jpg,.gif,.png,.jpeg,.bmp,.webp,.heic',
        2: '.jpg,.gif,.png,.jpeg,.bmp,.webp,.heic,.txt,.pdf,.docx,.doc,.xls,.xlsx,.log,.zip,.rar,.7z,.tiff,.cvs',
        3: '.zip',
      },
      disabled: false,
      imageUrl: '',
      isProgress: false,
      index: 0,
      uploadPercent: 0,
      dialog: {
        state: false,
        inputValue: '',
        index: 0,
      },
      closeImg:
        'data:image/png;base64,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',
    }
  },
  methods: {
    // 自定义上传
    uploadRequest(file) {
      /**
       * 自定义上传需要进行手动上传检测
       * beforeUploadHandler 若返回 false 或者返回 Promise 且被 reject，则停止上传
       * */
      const formData = new FormData()
      formData.append('file', file)
      !this.commonUpload && formData.append('mode', this.isPublic ? 1 : 0) // 0-私桶；1-公桶
      if (this.commonUpload) {
        formData.append('group', this.group)
        formData.append('code', this.code)
      }
      // 路径/fs/image/uploadAndScan仅作为需要校验敏感性的图片桶
      // 路径/fs/upload 不做敏感性图片校验
      const uploadPath = this.scannable ? '/fs/image/uploadAndScan' : '/fs/upload'
      const resultPath = this.commonUpload ? '/fs/standard/upload' : uploadPath
      axios({
        url: `${interfacePrefix}${resultPath}`,
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: ({ loaded, total }) => {
          this.isProgress = true
          this.disabled = true
          if (this.isAlone) { // 单张图片上传
            this.uploadPercent = parseInt(loaded / total * 100, 10)
          } else { // 多张图片上传
            const currentUploadFile = this.fileDataList.find((i) => i.uid === file.uid) || {}
            currentUploadFile.percentage = parseInt(loaded / total * 100, 10)
          }
        },
      })
        .then(({ data: { code, data, msg } }) => {
          if (this.scannable && code === 1 && data.suggestion !== 'block') {
            // 走敏感图校验需要额外判断data.suggestion
            // url：图片的http地址
            // suggestion：block时拦截
            // label：拦截的枚举，和商品库页面逻辑相同
            this.successHandle(data.url, file)
          } else if (!this.scannable && code === 1) {
            // 不走敏感图校验则只需判断code
            this.successHandle(data, file)
          } else {
            this.errorHandle(msg, file, data)
          }
        })
        .catch((error) => {
          this.errorHandle(error, file)
        })
    },
    beforeUploadHandler(file) {
      // 文件校验
      for (let i = 0, len = validPlugins.length; i < len; i++) {
        const plugin = validPlugins[i]
        if (!plugin.handle.call(this, file)) {
          this.$message.error(plugin.errorMsg.call(this))
          this.$refs.coreUpload.clearFile()
          return false
        }
      }

      /*
        重复文件校验开启
        有重复文件，阻断上传，根据用户返回结果进行处理
      */
      if (this.isCheckRepeat) {
        // 重复图片（按照图片名校验）
        const duplicateFile = this.accFileList.find((i) => i.name === file.name)
        if (duplicateFile) {
          this.duplicateFileMap.set(duplicateFile, file) // key-已上传的重复文件对象，value-当前文件
          this.checkRepeatConfirm()
          return false
        } else {
          this.beforeUploadNext(file)
        }
      } else {
        this.beforeUploadNext(file)
      }
    },
    beforeUploadNext(file) {
      const { uid, name } = file
      // 单个的图片的时候 有时候需要回显 下面的文字描述 fileTitle
      const title = !this.isAlone && !this.isTextType ? '' : this.fileTitle
      this.disabled = true
      const pushFileObj = {
        uid,
        name,
        title,
        status: 'uploading',
        percentage: 0,
        cancel: () => {},
      }
      this.pendingList.push(pushFileObj)
      this.$emit('uploadBefore')
    },
    // 重复文件弹框提示
    checkRepeatConfirm() {
      this.$confirm('当前所选的图片部分已上传完成，点击【确定】会覆盖系统原有图片，是否继续上传', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        /*
          先对之前的重名文件去重处理
          删除已上传的和当前所选文件名相同的图片
          将当前所选的图片添加到 pendingList 中
          然后进行手动上传
        */
        this.accFileList = uniqBy(this.accFileList, 'name')
        // 手动上传
        this.duplicateFileMap.forEach((value, key) => {
          const idx = this.accFileList.findIndex((j) => j.name === key.name)
          if (idx !== -1) {
            this.accFileList.splice(idx, 1)
            const pushFileObj = {
              uid: value.uid,
              name: value.name,
              title: key.title,
              status: 'uploading',
              percentage: 0,
              cancel: () => {},
            }
            this.pendingList.push(pushFileObj)
          }
        })
        // 文件上传
        this.duplicateFileMap.forEach((value) => {
          this.uploadRequest(value)
        })
      }).catch(() => { // 取消上传，清空重复队列
        this.duplicateFileMap.clear()
      })
    },
    successHandle(url, file) {
      /*
        1.上传成功后，变更pendingList中对象的状态，将status变更为success
        2.将上传成功的图片对象添加到fileList中
        3.更新fileData，过滤掉pendingList中已经上传成功的图片对象
        4.重复文件Map中删除已经上传成功的图片对象
        5.toast提示上传成功
        6.通知父组件，上传成功
        7.重置上传中变量状态
      */
      const successfulFile = this.pendingList.find((i) => i.uid === file.uid)
      successfulFile.url = url
      successfulFile.status = 'success'
      this.accFileList.push(successfulFile)
      this.pendingList = this.pendingList.filter((i) => i.status !== 'success')

      this.deleteRepeatFile(successfulFile)

      this.$message.success('上传成功！')
      this.$emit('uploadSuccess', url)
      this.resetVariable()
    },
    /*
      上传失败相关操作
      1.toast提示上传失败
      2.将失败的图片从正在上传队列中删除
      3.重复文件Map中删除已经上传成功的图片对象
      4.重置上传中变量状态
      5.通知父组件的上传失败事件
    */
    errorHandle(msg, file, data) {
      if (!this.scannable || (this.scannable && !data)) {
        // 集团员工照片、公司员工照片调用了Thirdparty敏感图校验
        // 报错先使用接口msg字段 其他场景保持不变
        if (codeList.includes(this.code)) {
          this.$message.error(msg)
        } else {
          this.$message.error('上传失败，请重新上传！')
        }
      }
      this.pendingList = this.pendingList.filter((i) => i.uid !== file.uid)
      this.deleteRepeatFile(file)
      this.resetVariable()
      this.$emit('uploadError', { msg, file, data })
    },
    // 重复文件Map中删除已经上传成功的图片对象
    deleteRepeatFile(file) {
      let wouldDeleteKey = null
      this.duplicateFileMap.forEach((value, key) => {
        if (value.uid === file.uid) {
          wouldDeleteKey = key
        }
      })
      if (wouldDeleteKey) {
        this.duplicateFileMap.delete(wouldDeleteKey)
      }
    },
    /*
      当次选中的文件和已上传的文件若超出最大上传个数limit，给出toast提示
      files:当次从文件选择框选中的文件
      fileList:当前已上传的文件列表
     */
    exceedHandle(files, fileList) {
      const remainAmount = this.limit - fileList.length
      if (fileList.length) {
        this.$message.error(`最多还可上传${this.isTextType ? `${remainAmount}个` : `${remainAmount}张`}，请重新选择`)
      } else {
        this.$message.error('已超出最大上传个数！')
      }
    },
    // 删除已上传成功的文件
    deleteUploadHandle(index) {
      if (index) {
        this.index = index
      } else {
        this.index = 0
      }
      this.accFileList.splice(this.index, 1)
      this.$emit('deleteUploadHandle')
    },

    editTxt(index) {
      const file = this.fileDataList[index]
      this.dialog.state = true
      this.dialog.index = index
      this.dialog.inputValue = file.title
      // this.$prompt('请输入自定义标题', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputValue: file.title,
      //   inputErrorMessage: '最多20位字符',
      //   closeOnClickModal: false,
      //   inputValidator: (value) => {
      //     if (value.length > 20) {
      //       return false
      //     }
      //   }
      // }).then(({ value }) => {
      //   file.title = value
      // })
    },
    changeCustomTitle() {
      this.fileDataList[this.dialog.index].title = this.dialog.inputValue
      this.dialog.state = false
    },
    /*
      清空上传相关状态
      1.单文件上传 或者是 多文件仅支持单选 的进度状态重置为0
      2.上传组件的disabled重置为false
        ①单文件上传：
          将disabled重置为false
        ②多文件上传：
          支持多选的情况下，所有的图片都上传成功才可将disabled重置为false
          仅支持单选，将disabled重置为false
    */
    resetVariable() {
      this.isProgress = false
      if (this.multiple) { // 支持多选的情况下，所有的图片都上传成功才可选取文件
        if (this.fileDataList.every((item) => item.status === 'success')) {
          this.disabled = false
        }
      } else { // 单文件上传 和 多文件上传，但是是一张一张上传，也需要将disabled重置为false
        this.uploadPercent = 0
        this.disabled = false
      }
    },
    // 非法数据格式处理-未来规范化可删除
    dataFilter() {
      const result = Array.isArray(this.fileList) && this.fileList.length
      if (!result) {
        this.imageUrl = ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
